<template>
  <v-card class="tab-content-container caption card-shadow">
    <v-tabs center-active v-model="tab" background-color="primary" show-arrows>
      <v-tabs-slider color="basil"></v-tabs-slider>

      <v-tab
        v-for="(document, index) in current_applicant.documents"
        :key="index"
        style="text-transform: capitalize !important; "
        >{{ document.name }}</v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(document, index) in current_applicant.documents"
        :key="index"
      >
        <v-card flat color="basil">
          <v-card-text class="body-2">
            <div>
              <div v-if="document.accordion">
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(item, i) in document.subfiles"
                    :key="i"
                  >
                    <div v-if="item.notAvaliable"></div>
                    <div v-else>
                      <v-expansion-panel-header>{{
                        item.name
                      }}</v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <div v-if="item.hasDetails">
                          <v-divider></v-divider>
                          <div class="d-flex flex-column my-4">
                            <v-row class="mx-0 pa-0 my-1 subtitle-1">
                              <v-col lg="2" md="2" sm="6" class="ma-0 pa-0">
                                Provided By:
                              </v-col>
                              <v-col class="ma-0 pa-0">
                                <span class="font-weight-medium ">{{
                                  item.Provider
                                }}</span>
                              </v-col>
                            </v-row>

                            <v-row class="mx-0 pa-0 my-1 subtitle-1">
                              <v-col lg="2" md="2" sm="6" class="ma-0 pa-0">
                                Position:
                              </v-col>
                              <v-col class="ma-0 pa-0">
                                <span class="font-weight-medium ">{{
                                  item.Role
                                }}</span>
                              </v-col>
                            </v-row>

                            <div
                              class="mx-0 pa-0 my-1"
                              v-for="(button, i) in item.Buttons"
                              :key="i"
                            >
                              <span v-if="button.fileLink">
                                <v-btn
                                  @click="opendoc(button.fileLink)"
                                  color="blue-grey"
                                  class="white--text body-2"
                                >
                                  {{ button.name }}
                                  <v-icon right dark>mdi-paperclip</v-icon>
                                </v-btn>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <v-divider></v-divider>

                          <span v-for="(button, i) in item.Buttons" :key="i">
                            <span v-if="button.fileLink">
                              <v-btn
                                @click="opendoc(button.fileLink)"
                                color="blue-grey"
                                class="my-2 mx-1 white--text body-2"
                              >
                                {{ button.name }}
                                <v-icon right dark>mdi-paperclip</v-icon>
                              </v-btn>
                            </span>
                          </span>
                        </div>
                      </v-expansion-panel-content>
                    </div>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div v-else>
                <div v-if="document.isText">
                  <v-btn
                    @click="motivationLetterOverlay = !motivationLetterOverlay"
                    color="blue-grey"
                    class="my-2 mx-1"
                    dark
                  >
                    {{ document.subfiles[0].Buttons[1].name }}
                    <v-icon right dark>mdi-eye</v-icon>
                  </v-btn>
                  <v-dialog
                    v-model="motivationLetterOverlay"
                    class="my-12 mx-2"
                    height="500px"
                    color="white"
                    max-width="700px"
                  >
                    <v-card style="overflow-x: hidden; word-break: break-word;">
                      <div class="d-flex justify-end align-center">
                        <v-btn icon @click="motivationLetterOverlay = false">
                          <v-icon color="black">mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <v-card-text class="d-flex justify-center align-center">
                        <div
                          class="py-4 px-2 grey--text text--darken-2 subtitle-2"
                        >
                          {{ document.subfiles[0].text }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
                <div v-else>
                  <v-btn
                    @click="opendoc(document.subfiles[0].Buttons[0].fileLink)"
                    color="blue-grey"
                    class="my-2 mx-1 white--text"
                  >
                    {{ document.subfiles[0].Buttons[0].name }}
                    <v-icon right dark>mdi-paperclip</v-icon>
                  </v-btn>
                  <!-- If Main selector show toggle v-model="people"-->
                  <div v-if="document.isPassport">
                    <div
                      v-if="
                        currentUser.isMainSelector != undefined &&
                          currentUser.isMainSelector == true
                      "
                    >
                      <div class="qualify-container">
                        <div>
                          <v-switch
                            label="Status"
                            color="#55BE5A"
                            v-model="current_applicant.isPassportValid"
                            @change="changeBoxValid()"
                          ></v-switch>
                        </div>
                        <div class="qualify-toggle-label">
                          <div
                            v-if="
                              current_applicant.isPassportValid == true
                                ? true
                                : false
                            "
                            class="d-inline accent-4 green--text"
                          >
                            Qualified!
                          </div>
                          <div
                            v-if="
                              current_applicant.isPassportValid == false
                                ? true
                                : false
                            "
                            class="d-inline red--text"
                          >
                            Disqualified!
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Ends here -->
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  name: 'Documents',
  data() {
    return {
      tab: null,
      motivationLetterOverlay: false,
    };
  },
  props: {
    current_applicant: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
  },
  methods: {
    changeBoxValid() {
      this.$emit('changeBoxValid', current_applicant._id);
    },
    opendoc(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped>
.tab-content-container {
  min-height: 345px;
}

.qualify-container {
  display: flex;
  align-items: center;
}
.qualify-toggle-label {
  margin-left: 6px;
  padding-bottom: 2px;
}
.card-shadow {
  box-shadow: 0px 0px 75px #00000024 !important;
}
</style>
